const pathKey = {
  loginPath: '/login',
  homePath: '/',
  errorPath: '*',
  afterSaleManagePath: '/afterSaleManage',
  familyStatusPath: '/familyPage',
  infoManagePath: '/infoManagePage',
  familyStatusDetailPath: '/familyPage/familyStatusDetail',
  familyEquipmentDetailPath: '/familyPage/familyEquipmentDetail',
  familyStatusWaterDetail: '/familyPage/familyStatusDetail/Water',
  familyStatusGasDetail: '/familyPage/familyStatusDetail/Gas',
  familyStatusElectricityDetail: '/familyPage/familyStatusDetail/Electricity',
  familyStatusEnvironmentDetail: '/familyPage/familyStatusDetail/Environment',
  familyStatusSmartEnergyPath: '/familyPage/familyStatusDetail/SmartEnergy',
  energyDetail: '/familyPage/familyStatusDetail/Electricity/energyDetail'
}
export default pathKey;





// WEBPACK FOOTER //
// ./src/router/routerKey.js